import { useEffect, useState } from 'react';
import { getAllClients, getAllReportsAdmin } from '../../api/reports.api';

import StatsCards from './components/StatsCards';
import LatestReports from './components/LatestReports';
import NewClientModal from './components/NewClientModal';

export default function Dashboard() {
  const [reports, setReports] = useState([]);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showNewClientModal, setShowNewClientModal] = useState(false);
  const load = async () => {
    setLoading(true);
    try {
      const [r, c] = await Promise.all([getAllReportsAdmin(), getAllClients()]);

      setReports(r.data.reports || []);
      setClients(c.data.clients || []);
    } catch (err) {
      console.error('Dashboard load error:', err);
    }
    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  if (loading) return <p>در حال بارگذاری...</p>;

  return (
    <div className="space-y-8">
      <h1 className="text-2xl font-bold mb-4">داشبورد مربی</h1>

      <StatsCards reports={reports} clients={clients} />
      <button
        onClick={() => setShowNewClientModal(true)}
        className="px-4 py-2 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700 transition">
        افزودن کلاینت جدید
      </button>
      {showNewClientModal && (
        <NewClientModal
          open={showNewClientModal}
          onClose={() => setShowNewClientModal(false)}
          onSuccess={load}
        />
      )}
      <LatestReports reports={reports} />
    </div>
  );
}
